/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FC, PropsWithChildren } from "react";

export const SearchResultListWrapper: FC<PropsWithChildren<unknown>> = (
  props
) => {
  const { children } = props;

  return <div css={rootStyle}>{children}</div>;
};

const rootStyle = css`
  margin-inline: auto;
  max-width: 1018px;
  width: 90%;
`;
